if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) return;

        const mediaId = this.openedBy.getAttribute('data-media-id');
        if (!mediaId) return;

        this.querySelectorAll('[data-media-id]').forEach((element) => {
          const isActive = element.getAttribute('data-media-id') === mediaId;
          element.classList.toggle('active', isActive);
          if (isActive) {
            element.classList.remove('product__media-item--inactive-option');
          }
        });

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.scrollIntoView({ block: 'nearest', inline: 'nearest' });

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = 0;
          const activeImage = activeMedia.querySelector('img');
          if (activeImage) {
            const imageWidth = activeImage.getBoundingClientRect().width;
            if (imageWidth > container.clientWidth) {
              container.scrollLeft = (imageWidth - container.clientWidth) / 2;
            }
          }
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
